import React, { useEffect, useState } from 'react';
import GenericDialog from "@common/GenericDialog";

const StudentResourcesDialog = ({ visible, onClose, selectedStudent, classStudents }) => {
    const [syllabuses, setSyllabuses] = useState([]);

    useEffect(() => {
        if (visible && selectedStudent) {
            const matchedStudent = classStudents.find(student => student.userId === selectedStudent.studentId);
            setSyllabuses(matchedStudent?.syllabuses || []);
        }
    }, [visible, selectedStudent, classStudents]);

    return (
        <GenericDialog
            title={"Resources"}
            dialogWidth={500}
            open={visible}
            onClose={onClose}
            buttons={[{name: 'Close'}]}>
            <>
                <ul>
                    {syllabuses.map((syllabus, index) => (
                        <li key={index}>{syllabus.syllabusName}</li>
                    ))}
                </ul>
            </>
        </GenericDialog>
    );
};

export default StudentResourcesDialog;